<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex mb-10">
        <ManyAvatar :size="1" :data="data" symbol-size="30px"/>
        <div class="p-5 d-flex align-items-start fs-5 ms-5" @click="showPublish" style="border-radius: 5px; width: 95%; background-color: #f5f8fa;" v-if="!publish">
          {{ $t('projects.publish_text') }}...
        </div>
        <div class="p-5 ms-5" v-else style="width: 95%; background-color: #f5f8fa;">
          <form @submit.prevent="submitComment">
            <div class="d-flex justify-content-end mb-5">
              <i class="fas fa-times" @click="showPublish"></i>
            </div>
            <div class="mb-5">
              <div class="d-flex mb-3">
                <div
                    class="card d-flex gap-3 flex-row align-items-center shadow rounded-2 p-2">
                  <i v-for="(reaction, index) in reactionEnum"
                     @click.prevent="makeReact(reaction.value)"
                     :key="index"
                     class="fa cursor-pointer hovering-zoom"
                     v-html="reaction.value"
                     style="font-size: 1.2rem"
                  ></i>
                </div>
              </div>
              <CKEditor @text="writeText" :content="content" id="comment-editor" ktClass="h-50px" :with-image="false"/>


            </div>
            <div class="d-flex justify-content-end">
              <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.send" size="7px 30px" :is-loading="isLoading"></Button>
            </div>
          </form>
        </div>
      </div>

      <div v-for="comment in comments" class="d-flex mb-10" :key="comment.id">
        <ManyAvatar :size="1" :data="getUserData(comment.user)" symbol-size="30px"/>
        <div class="ms-5" style="width: 95%;">
          <div class="d-flex justify-content-between mb-2">
            <h1>{{ comment.user.fullname }}</h1>
            <p>
              {{ format(comment.created_at) }}
              <i @click.prevent="deleteComment(comment.id)" class="fas fa-trash fs-5 ms-3 cursor-pointer"></i>
            </p>
          </div>
          <div class="p-8 fs-5" style="border-radius: 5px; width: 100%; background-color: #f5f8fa;" v-html="comment.comment"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref, computed, onUnmounted} from "vue";
import {useStore} from "vuex";
import Button from "@/components/Button";
import {useRoute} from 'vue-router';
import ManyAvatar from "@/components/ManyAvatar";
import CKEditor from "@/components/CKEditor.vue";
import i18n from "@/plugins/i18n";
import {useSwal} from "@/composables/useSwal";
import {formatDistance} from "date-fns";
import {fr} from "date-fns/locale";

const store = useStore()
const route = useRoute()
const {showSwal} = useSwal()

const publish = ref(false)
const isLoading = ref(false)
const content = ref("")
const nowDate = ref(new Date())
const setIntervalId = ref(null)

function getUserData(user) {
  return [
    {
      firstname: user?.firstname || '', lastname: user?.lastname || '', link: user?.image
    }
  ]
}
const reactionEnum = computed(() => store.getters['projects/getProjectReactionEnum'])
let comments = computed(() => store.getters['projects/getProjectComments'](route.params.id))

function showPublish(){
  publish.value = !publish.value
}

function writeText(text) {
  content.value = text
}

function makeReact(comment) {
  store.dispatch('projects/createComment', {comment: comment, id: route.params.id})
      .then(res => {})
      .catch(() => {})
      .finally(() => {})
}

onMounted(() => {
  store.dispatch('projects/loadProjectReactionEnum')
  store.dispatch('projects/loadProjectComments', route.params.id)

  setIntervalId.value = setInterval(() => {
    nowDate.value = new Date()
  }, 1000)

})

onUnmounted(() => {
  if(setIntervalId.value) {
    clearInterval(setIntervalId.value)
  }
})

function format(date){
  return formatDistance(new Date(date), nowDate.value, { locale: fr})
}

async function submitComment() {
  isLoading.value = true

  try {
    await store.dispatch('projects/createComment', {
      comment: content.value,
      id: route.params.id
    })

    window.toastr['success'](i18n.global.t('notification.comments_created'))

    content.value = ""

    isLoading.value = false
  }catch (e) {
    isLoading.value = false
  }
}

async function deleteComment(id) {
  showSwal(
      i18n.global.t('swal.title'),
      i18n.global.t('swal.project_comments_deleted')
  ).then( async (result) => {
    if (result.value) {
      store.dispatch('projects/deleteProjectComment', {
        id: id,
        project: route.params.id
      }).then((res) => {
        window.toastr['success'](i18n.global.t('notification.comments_deleted'))
      }).catch(() => {

      })
    }
  })
}

</script>
<style scoped>
.report-comment-action {
  opacity: 0;
  pointer-events: none;
  transform: translateY(-5px);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.report-card:hover .report-comment-action {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
}
</style>